export { BvlFormAlertComponent as BvlFormAlert } from './form-alert.component';
export { BvlFormAlertModule } from './form-alert.module';
